import { render } from "./TemplateDeleteModal.vue?vue&type=template&id=cbfd85da"
import script from "./TemplateDeleteModal.vue?vue&type=script&lang=js"
export * from "./TemplateDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__